module.exports = __webpack_public_path__ + "static/media/esg_picture_body.f5738fa9.svg";